// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"26":"ee528fb2","236":"da6d7d42","363":"198179df","926":"82d080b6"}[chunkId] + ".css";
};